export const inPc = (() => {
    var sUserAgent = navigator.userAgent;
    if (sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1 || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1) {
        return false
    } else {
        return true
    }
})();

function linearGradient(deg, start, stop) {
    return `linear-gradient(${deg}deg,  ${start}, ${stop})`
}

// function shadow(color) {
//     return `0px 0px .4rem ${color}`
// }


// card
// block input
// text
// button
// alert
// draw

// size
// background
// border

const background = [
    {
        // #7fc248,#63bb35
        // background: 'linear-gradient(45deg,rgb(252 255 244),rgb(255 247 238 / 88%))',
        // @0
        background: 'linear-gradient(360deg, rgb(32, 32, 32), rgb(36 35 35))',
        
        // backgroundImage: 'url(./.png)',
        // border: '1rem solid transparent',
    },
    {
        // #7fc248,#63bb35
        // @1
        background: 'linear-gradient(45deg, #00E0B8, #006CE6)'
    },
    {
        // @2
        background: 'linear-gradient(45deg, rgb(255 109 109 / 95%), rgb(232 80 0 / 95%))'
    },
    { 
        // @3
        background: `linear-gradient(137deg, rgb(171 255 153), rgb(96 196 0))`
    },
    {
        // @4
        background: 'linear-gradient(122deg, #FFD84F, #FFED8F)'
    },
    {
        // @5
        background: 'linear-gradient(122deg, #00E0B8, #006CE6)'
    },
    {
        // @6
        background: `#e8edc8`,
        // border: '0.1rem solid transparent',
        backgroundClip: 'padding-box, border-box',
        backgroundOrigin: 'padding-box, border-box'
    },
    {
        // @7
        background: `linear-gradient(136deg,#fee8b2,#ffbcbc)`,
        // border: '0.1rem solid transparent',
        backgroundClip: 'padding-box, border-box',
        backgroundOrigin: 'padding-box, border-box'
    },
    {
        // @8
        // #7fc248,#63bb35
        background: '#000',
        color: 'rgb(255, 255, 255)',
        border: '1px solid rgb(95 79 20)'
        // backgroundClip: 'padding-box, border-box',
        // backgroundOrigin: 'padding-box, border-box',
        // border: '1rem solid transparent',
    },
    {
        // @9
        background: '#000'
    },
    {
        // @10
        background: 'linear-gradient(90deg, rgb(243, 80, 60), rgb(254, 6, 240))'
    },
    {
        // @11
        background: 'linear-gradient(90deg, rgb(255, 211, 4), rgb(255, 114, 99))'
    },
    {
        // @12
        background: 'linear-gradient(90deg, rgb(7, 214, 255), rgb(211, 76, 255))'
    }
]

const color = [
    '#FFFFFF',
    '#000',
    '#a4a39e',
    '#FED215',
    '#8AE4FF',
    '#9da5ad',
    "#4B5563",
    '#6B7280',
    '#292D32',
    '#9CA3AF',
];

const size = new Array(7).fill(1.3).map((v,i) => v * (1.382**i));




const theme = {
    // public
    MAX_WIDTH: 1080,
    isPc: inPc,
    isV2: window.location.hostname.split(".")[0] !== 'v3',
    bodyBack: 'rgb(0, 0, 0)',
    tableBackground: '#f2f2f2',
    footerHeight: '5.2rem',
    borderRadius: '18px',
    boxShadow: '0px 0px 6px rgba(0,0,0,.2)',
    active: '#F3503C',
    testLinear: [`background: linear-gradient(90deg, rgb(255, 211, 4), rgb(255, 114, 99))`, 'background: linear-gradient(120deg,#ff8a38,#ff5400,#ff8a38)'],
    hrBackground: 'linear-gradient(120deg, rgb(239 230 206 / 6%), rgb(248 205 49 / 60%), rgb(239 230 206 / 6%))',
    headBarBackground: '#000',
    // font
    size,
    padding: size.map(v => `${v * 0.618}rem ${v}rem`),
    // 由亮 到 暗
    // 字体颜色
    color,
    buttonSize: [
        // small
        {
            fontSize: '1rem',
            padding: '.6rem 1.2rem',
            // borderRadius: '0rem',
        },
        {
            // @1
            fontSize: '1.4rem',
            padding: '1rem 1.4rem',
        },
        {
            // @2
            fontSize: '1.8rem',
            padding: '1.4rem 1.8rem',
        },
        {
            // @3
            fontSize: '2.6rem',
            padding: '1.4rem 1.8rem',
        },
        {
            // @4
            fontSize: '3rem',
            padding: '1.4rem 1.8rem',
        },
        {
            // @5
            fontSize: '1.4rem',
            padding: '.6rem 1.2rem',
        },
    ],
    // 由 亮 变 暗
    block: [
        background[0],
        background[1],
        background[2],
        background[3],
        background[4],
        background[5],
        background[6],
        background[7],
        background[8],
        background[9],
    ],
    draw: background[2],
    // 由 亮 变 暗
    button: [
        // normal
        {
            ...background[4],
            color: color[1]
        },
        // normalA
        {
            ...background[5],
            color: color[1]
        },
        // normalB
        {
            ...background[3],
            color: color[1]
        },
        // border
        {
            ...background[6],
            color: color[1]
        },
        // disabled
        {
            background: '#000',
            color: 'rgb(106 106 106) !important',
            border: '1px solid #565656'
        },
        // active
        {
            ...background[12],
            color: color[1]
        },
        // un active
        {
            // @6
            ...background[8],
            // color: color[1]
        },
        {
            // @7
            ...background[10],
            color: color[1]
        },
        {
            // @8
            ...background[11],
            color: color[1]
        }
        // ...other
    ],
    squareDot: [
        background[8],
        background[9]
    ]
}

export default theme